module.exports = __webpack_public_path__ + "img/writing-check.png";